import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { PrivateRoute } from './components/PrivateRoute';
import { Layout } from './components/Layout';
import { CustomerLayout } from './components/CustomerLayout';
import { UserType } from './types';

import { Home } from './pages/public/Home';
import { Login } from './pages/public/Login';
import { Register } from './pages/public/Register';
import { LoanProducts } from './pages/public/LoanProducts';
import ForgotPassword from './pages/public/ForgotPassword';
import ResetPassword from './pages/public/ResetPassword';
import GuarantorAuthorization from './pages/public/GuarantorAuthorization';

import { Dashboard } from './pages/customer/Dashboard';
import { MyApplications } from './pages/customer/MyApplications';
import { NewApplication } from './pages/customer/NewApplication';
import { MyLoans } from './pages/customer/MyLoans';
import { LoanDetails } from './pages/customer/LoanDetails';
import { PaymentCallback } from './pages/customer/PaymentCallback';
import { Documents } from './pages/customer/Documents';
import { NotificationSettings } from './pages/customer/NotificationSettings';
import { ProfileSettings } from './pages/customer/ProfileSettings';
import Support from './pages/customer/Support';
import SupportTicketDetailsCustomer from './pages/customer/SupportTicketDetails';
import Help from './pages/customer/Help';

import './styles/designSystem.css';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/login" element={<Layout><Login /></Layout>} />
          <Route path="/register" element={<Layout><Register /></Layout>} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/loan-products" element={<Layout><LoanProducts /></Layout>} />
          <Route path="/guarantor/:token" element={<Layout><GuarantorAuthorization /></Layout>} />

          {/* Customer Routes */}
          <Route
            path="/customer/dashboard"
            element={
              <PrivateRoute requiredType={UserType.CUSTOMER}>
                <CustomerLayout><Dashboard /></CustomerLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/customer/applications"
            element={
              <PrivateRoute requiredType={UserType.CUSTOMER}>
                <CustomerLayout><MyApplications /></CustomerLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/customer/applications/new"
            element={
              <PrivateRoute requiredType={UserType.CUSTOMER}>
                <CustomerLayout><NewApplication /></CustomerLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/customer/loans"
            element={
              <PrivateRoute requiredType={UserType.CUSTOMER}>
                <CustomerLayout><MyLoans /></CustomerLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/customer/loans/:id"
            element={
              <PrivateRoute requiredType={UserType.CUSTOMER}>
                <CustomerLayout><LoanDetails /></CustomerLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/payment/callback"
            element={
              <PrivateRoute requiredType={UserType.CUSTOMER}>
                <CustomerLayout><PaymentCallback /></CustomerLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/customer/documents"
            element={
              <PrivateRoute requiredType={UserType.CUSTOMER}>
                <CustomerLayout><Documents /></CustomerLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/customer/settings/notifications"
            element={
              <PrivateRoute requiredType={UserType.CUSTOMER}>
                <CustomerLayout><NotificationSettings /></CustomerLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/customer/settings/profile"
            element={
              <PrivateRoute requiredType={UserType.CUSTOMER}>
                <CustomerLayout><ProfileSettings /></CustomerLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/customer/support"
            element={
              <PrivateRoute requiredType={UserType.CUSTOMER}>
                <CustomerLayout><Support /></CustomerLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/customer/support/:ticketId"
            element={
              <PrivateRoute requiredType={UserType.CUSTOMER}>
                <CustomerLayout><SupportTicketDetailsCustomer /></CustomerLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/customer/help"
            element={
              <PrivateRoute requiredType={UserType.CUSTOMER}>
                <CustomerLayout><Help /></CustomerLayout>
              </PrivateRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
